import { render } from "./FormDbItem.vue?vue&type=template&id=6b17e2f2"
import script from "./FormDbItem.vue?vue&type=script&lang=js"
export * from "./FormDbItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__